import { render, staticRenderFns } from "./MainStudyCover.vue?vue&type=template&id=06d992b2&scoped=true"
import script from "./MainStudyCover.vue?vue&type=script&lang=js"
export * from "./MainStudyCover.vue?vue&type=script&lang=js"
import style0 from "./MainStudyCover.vue?vue&type=style&index=0&id=06d992b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d992b2",
  null
  
)

export default component.exports